import { apiSlice } from "./apiSlice";
import { GET_CATEGORIES_URL } from "../constants";

export const categorySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => ({
        url: GET_CATEGORIES_URL,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetCategoriesQuery } = categorySlice;
